import { render, staticRenderFns } from "./BorrowMenubar.vue?vue&type=template&id=700c87fe&scoped=true&"
import script from "./BorrowMenubar.vue?vue&type=script&lang=js&"
export * from "./BorrowMenubar.vue?vue&type=script&lang=js&"
import style0 from "./BorrowMenubar.vue?vue&type=style&index=0&id=700c87fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c87fe",
  null
  
)

export default component.exports